import styled from 'styled-components';

export const StyledTeachingMaterialContainer = styled.div.attrs(props => ({
  className: props.className
}))`
  > * {
    pointer-events: auto;
  }
`;

export const ControlWrap = styled.div`
  position: absolute;
  top: 150px;
  left: 150px;

  &.videoBox{
    width: 400px;
    height: 300px;
    background-color: #232323;
  }

  &.audioBox{
    width: 400px;
    height: 84px;
    padding: 15px;
    background-color: #232323;
  }

  &.iframeBox{
    padding: 15px;
    width: 650px;
    height: 430px;
    background-color: #232323;
  }

  audio {
    width: 100%;
  }

  video {
    width: 100%;
    height: 100%;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
`;